// @core/api/endpoints/affiliate/update_offer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OfferResponse,
  UpdateOfferRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Update offer
 * Updates an existing offer with the provided data. Returns the updated resource.
 */
export async function UpdateOffer(
  offer_id: string,
  data: UpdateOfferRequest,
  options?: RequestOptions
): Promise<OfferResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.patch<OfferResponse>(requestPath, data, requestOptions);
}
